import { createSelector } from 'reselect';

import { missingAuthParamsErrorCodes } from '@ezugi/constants/errors';
import ss from '@ezugi/utils/helpers/sessionstorage';

export const appSelector = (state) => state.app;

export const appLoadedSelector = createSelector(
  appSelector,
  (app) => app?.loaded
);

export const appErrorSelector = createSelector(
  appSelector,
  (app) => app?.error
);
export const appErrorCodeSelector = createSelector(appErrorSelector, (error) => error?.code);

export const isAuthParamsErrorSelector = createSelector(
  appErrorCodeSelector,
  (code) => missingAuthParamsErrorCodes.includes(code)
);

export const showNavigationSelector = createSelector(
  isAuthParamsErrorSelector,
  (isAuthError) => {
    if (!isAuthError) {
      return true;
    }
    return !!ss.has('home_url')[1];
  }
);
